"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
*
* 从getter中取数据到组件中
*
*/
var skin = exports.skin = function skin(state) {
  return state.skin;
};
var token = exports.token = function token(state) {
  return state.token;
};
var datumValue = exports.datumValue = function datumValue(state) {
  return state.datumValue;
};
var datumObj = exports.datumObj = function datumObj(state) {
  return state.datumObj;
};
var menuActiveName = exports.menuActiveName = function menuActiveName(state) {
  return state.menuActiveName;
};
var menuOpenName = exports.menuOpenName = function menuOpenName(state) {
  return state.menuOpenName;
};
var pageSize = exports.pageSize = function pageSize(state) {
  return state.pageSize;
};
var modelDisabled = exports.modelDisabled = function modelDisabled(state) {
  return state.modelDisabled;
};
var crumbsList = exports.crumbsList = function crumbsList(state) {
  return state.crumbsList;
};
var menuList = exports.menuList = function menuList(state) {
  return state.menuList;
};
var bindPhone = exports.bindPhone = function bindPhone(state) {
  return state.bindPhone;
};
var helpSelected = exports.helpSelected = function helpSelected(state) {
  return state.helpSelected;
};